export default class InvalidQuantityError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'InvalidQuantityError';
    Object.setPrototypeOf(this, InvalidQuantityError.prototype);
  }
}
